module.exports = __webpack_public_path__ + "img/google-auth.f566ab56.png";